import React, { useEffect, useState, useCallback } from "react";
import { Box, Button, Typography, CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";

// Conexao rapida do WhatsApp oficial (Cadastro incorporado da Meta).
//
// Convive com a conexao por credencial propria — nao substitui. O cliente
// escolhe: clicar e autorizar, ou colar phoneNumberId, wabaId e token.
//
// A Meta devolve DUAS coisas por caminhos diferentes: o codigo, pelo retorno do
// login, e os identificadores da conta e do numero, por uma mensagem da janela.
// Por isso escutamos a mensagem antes de abrir o login.

const carregarSdk = (appId) =>
  new Promise((resolve, reject) => {
    if (window.FB) return resolve(window.FB);

    window.fbAsyncInit = function () {
      window.FB.init({ appId, cookie: true, xfbml: false, version: "v23.0" });
      resolve(window.FB);
    };

    const existente = document.getElementById("facebook-jssdk");
    if (existente) return;

    const s = document.createElement("script");
    s.id = "facebook-jssdk";
    s.src = "https://connect.facebook.net/pt_BR/sdk.js";
    s.async = true;
    s.defer = true;
    s.onerror = () => reject(new Error("Não foi possível carregar o SDK da Meta"));
    document.body.appendChild(s);
  });

const BotaoConexaoRapida = ({ aoConectar }) => {
  const [config, setConfig] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  const dadosDaJanela = React.useRef({});

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/whatsapp-official/conexao-rapida/config");
        setConfig(data);
        if (data?.disponivel) carregarSdk(data.appId).catch(() => {});
      } catch (e) {
        setConfig({ disponivel: false });
      }
    })();
  }, []);

  // A janela da Meta avisa a conta e o numero por postMessage.
  useEffect(() => {
    const aoReceber = (ev) => {
      if (!String(ev.origin || "").includes("facebook.com")) return;
      try {
        const dados = typeof ev.data === "string" ? JSON.parse(ev.data) : ev.data;
        if (dados?.type !== "WA_EMBEDDED_SIGNUP") return;
        if (dados?.data?.waba_id) dadosDaJanela.current.wabaId = dados.data.waba_id;
        if (dados?.data?.phone_number_id) {
          dadosDaJanela.current.phoneNumberId = dados.data.phone_number_id;
        }
      } catch (e) {
        // mensagem de outro formato, ignora
      }
    };
    window.addEventListener("message", aoReceber);
    return () => window.removeEventListener("message", aoReceber);
  }, []);

  const conectar = useCallback(async () => {
    if (!config?.disponivel) return;
    setOcupado(true);
    dadosDaJanela.current = {};

    try {
      const FB = await carregarSdk(config.appId);

      const tratarRetorno = async (resposta) => {
          const codigo = resposta?.authResponse?.code;
          if (!codigo) {
            setOcupado(false);
            toast.info("Conexão cancelada.");
            return;
          }

          const { wabaId, phoneNumberId } = dadosDaJanela.current;
          if (!wabaId || !phoneNumberId) {
            setOcupado(false);
            toast.error(
              "A Meta não informou a conta ou o número. Refaça a autorização até o fim."
            );
            return;
          }

          try {
            const { data } = await api.post("/whatsapp-official/conexao-rapida", {
              codigo,
              wabaId,
              phoneNumberId
            });
            toast.success("WhatsApp conectado.");
            if (aoConectar) aoConectar(data);
          } catch (e) {
            toastError(e);
          }
          setOcupado(false);
      };

      FB.login(
        (resposta) => {
          tratarRetorno(resposta);
        },
        {
          config_id: config.configId,
          response_type: "code",
          override_default_response_type: true,
          extras: {
            setup: {},
            featureType: "whatsapp_business_app_onboarding",
            sessionInfoVersion: "3"
          }
        }
      );
    } catch (e) {
      setOcupado(false);
      toast.error(e?.message || "Não foi possível abrir a janela da Meta.");
    }
  }, [config, aoConectar]);

  if (!config) return null;
  if (!config.disponivel) return null;

  return (
    <Box
      style={{
        border: "1px solid #d7dde3",
        borderRadius: 10,
        padding: 16,
        marginBottom: 16,
        background: "#f8fbfd"
      }}
    >
      <Typography style={{ fontWeight: 700, marginBottom: 4 }}>
        Conexão rápida
      </Typography>
      <Typography style={{ fontSize: 13, color: "#667781", marginBottom: 12 }}>
        Leia um QR Code no seu WhatsApp Business e pronto. O número continua
        funcionando no aplicativo — sem criar app, sem gerar token, sem copiar
        identificadores.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={conectar}
        disabled={ocupado}
        startIcon={ocupado ? <CircularProgress size={16} color="inherit" /> : null}
        style={{ textTransform: "none", fontWeight: 600 }}
      >
        {ocupado ? "Conectando..." : "Conectar com a Meta"}
      </Button>
    </Box>
  );
};

export default BotaoConexaoRapida;
